import ReactMarkdown from 'react-markdown';

export interface MarkdownProps {
  /** 렌더할 마크다운 원문(CommonMark). */
  children: string;
}

/**
 * 디자인시스템 토큰으로 렌더하는 범용 마크다운 뷰. `@tailwindcss/typography`(`prose`)가 태그별
 * 스타일을, `prose-heviton`(globals.css)이 색을 heviton 토큰에 매핑한다(다크모드 자동). 태그별
 * 컴포넌트 매핑 없음. CommonMark 만 — GFM(표·취소선)은 필요 시 `remark-gfm` 추가. 도메인 무지 —
 * 약관·공지·도움말 등이 재사용.
 */
export function Markdown({ children }: MarkdownProps) {
  return (
    <div className="prose prose-sm prose-heviton max-w-none">
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  );
}
